module.exports = __webpack_public_path__ + "static/media/PDF_75.c6286536.pdf";